/** Benelli M4. Gas-operated 12 gauge: no pump between shells, so the follow-up is the whole gun. */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const BENELLI_M4 = {
  id: 'benelliM4',
  label: 'Benelli M4',
  classId: 'shotgun',
  caliber: '12 gauge',
  fireMode: 'semi',
  roundsPerMinute: 200,
  magSize: 8,
  reserveAmmo: 40,
  reloadSeconds: 0.5,
  emptyReloadSeconds: 0.5,
  reloadStyle: 'shell',
  damage: 11,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 12, zeroMetres: 45, minScale: 0 },
  pellets: 9,
  adsSpreadMoa: 95,
  hipSpreadMoa: 185,
  bloomMoaPerShot: 0,
  bloomMoaCap: 0,
  bloomDecayMoaPerSecond: 0,
  moveSpreadMoaPerMps: 11,
  crouchSpreadScale: 0.8,
  airborneSpreadMoa: 45,
  recoilPattern: [
    { pitch: 2.2, yaw: 0.2 },
    { pitch: 2.1, yaw: -0.25 },
    { pitch: 2.0, yaw: 0.15 },
  ],
  recoilResetSeconds: 0.5,
  recoilRecoveryPerSecond: 5.5,
  adsFovDegrees: 62,
  adsSeconds: 0.26,
  adsSensitivityScale: 0.85,
  muzzleVelocity: 400,
} as const satisfies WeaponSpec;
